import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

interface OrderCheckingStatusInfoProps {
}

const OrderCheckingStatusInfo: React.FC<OrderCheckingStatusInfoProps> = ({ }) => {
    return (
        <>
            <Box display={"flex"} flexDirection={"row"} alignItems={'center'} gap={2}>
                <CheckCircleTwoToneIcon color='success' fontSize='large' />
                <Typography variant='subtitle2' fontWeight={600}>Restoran je primio tvoju narudžbu.</Typography>
            </Box>
            <Box display={"flex"} flexDirection={"row"} alignItems={'center'} gap={2}>
                <Box height={{ xs: 30.63, sm: 35 }} width={{ xs: 30.63, sm: 35 }}>
                    <CircularProgress size={30} />
                </Box>

                <Typography variant='subtitle2' color={"text.secondary"}>Pregled narudžbe, molimo pričekaj...</Typography>
            </Box>
        </>
    )
}

export default OrderCheckingStatusInfo;